<template> 
  <HomeInicio />

  <div v-if="paquete === 3 || paquete === 4" class="container">
    <div class="upload-container">
      <h2>Sube tu Lista de Invitados</h2>
      <p>
        Aquí puedes subir tu archivo Excel de invitados. 
        Debe ser un archivo con extensión <strong>.xls</strong> o <strong>.xlsx</strong>.
      </p>

      <input type="file" accept=".xls, .xlsx" class="form-control" @change="handleFileUpload" />

      <button class="btn btn-success mt-3" @click="subirArchivo">
        <i class="fas fa-upload" /> Subir Archivo
      </button>

      <p v-if="!selectedFile && fileMessage" class="text-warning">
        No has cargado ningún archivo en Excel.
      </p>
    </div>

    <!-- Video Tutorial Debajo del Formulario -->
   <!-- Mini video flotante -->
<div class="video-float" @click="mostrarVideo = true">
  <video muted autoplay loop playsinline>
    <source src="@/assets/tutorial_subir.webm" type="video/webm" />
  </video>
  <span class="video-tooltip">Ver tutorial</span>
</div>

<!-- Modal ampliado -->
<div v-if="mostrarVideo" class="video-modal" @click.self="mostrarVideo = false">
  <div class="video-modal-content">
    <video v-if="mostrarVideo" controls autoplay>
  <source src="@/assets/tutorial_subir.webm" type="video/webm" />
</video>
    <button class="cerrar-video" @click="mostrarVideo = false">×</button>
  </div>


    </div>
  </div>

  <div v-else class="nodisponible">
    <p>Esta sección no está disponible en el paquete contratado.</p> 
  </div>
</template>


<script>
import baseUrl from '../api';
import HomeInicio from "@/components/HomeInicio.vue";
import Swal from 'sweetalert2';

export default {
  name: "SubirLista",
  components: {
    HomeInicio,
  },
  data() {
    return {
      paquete: Number(localStorage.getItem('paquete')),
      excelData: [],
      excelHeaders: [],
      idFestejada: null,
      selectedFile: null,
      fileMessage: false,
      isUploaded: false,
      mostrarVideo: false, // 👈 para controlar el modal

    };
  },
  mounted() {
    this.idFestejada = localStorage.getItem("id_festejada") || null;
    if (!this.idFestejada) {
      alert("No tienes acceso. Inicia sesión.");
      this.$router.push({ name: "Login" });
    }
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      if (file.name.endsWith(".xls") || file.name.endsWith(".xlsx")) {
        this.selectedFile = file;
        this.fileMessage = false;
      } else {
        this.selectedFile = null;
        alert("Solo se permiten archivos en Excel. Favor sube el archivo correcto.");
        this.fileMessage = true;
      }
    },
    async subirArchivo() {
      if (!this.selectedFile) {
        this.fileMessage = true;
        return;
      }

      const idFestejada = localStorage.getItem('id_festejada');
      const formData = new FormData();
      formData.append('file', this.selectedFile);
      formData.append('id_festejada', idFestejada);
      formData.append('paquete', this.paquete);
      formData.append('url_invitacion', '');

      try {
        const response = await fetch(`${baseUrl}/api2/upload-excel`, {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) throw new Error('Error al subir el archivo');

        const result = await response.json();
        Swal.fire('Éxito', result.message, 'success');
        this.isUploaded = true;
        setTimeout(() => location.reload(), 1500);

      } catch (error) {
        console.error('Error al subir el archivo:', error);
        Swal.fire('Error', 'Hubo un error al subir el archivo.', 'error');
      }
    },
  },
};
</script>

<style scoped>
.container {
  padding-top: 100px;
}
.upload-container {
  position: relative;
  max-width: 620px;
  margin: 0 auto;
  text-align: center;
  padding: 40px 30px;
  border-radius: 24px;
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.04);
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  z-index: 1;
  overflow: hidden;
}

/* Asegúrate de que el contenido esté arriba */
.upload-container * {
  position: relative;
  z-index: 2;
}

/* Círculo superior izquierdo */
.upload-container::before {
  content: "";
  position: absolute;
  top: -50px;
  left: -50px;
  width: 120px;
height: 120px;

  background: radial-gradient(circle, #f1e5dc, transparent 70%);
  border-radius: 60%;
  z-index: 0;
  opacity: 0.2;
  filter: blur(20px);
}

/* Círculo inferior derecho */
.upload-container::after {
  content: "";
  position: absolute;
  bottom: -50px;
  right: -50px;
  width: 120px;
height: 120px;

  background: radial-gradient(circle, #f1e5dc, transparent 70%);
  border-radius: 60%;
  z-index: 0;
  opacity: 0.2;
  filter: blur(20px);
}
@keyframes shimmer {
  0%, 100% { transform: scale(1) translate(0, 0); }
  50% { transform: scale(1.1) translate(10px, -10px); }
}

.upload-container::before {
  animation: shimmer 6s ease-in-out infinite;
}

.upload-container::after {
  animation: shimmer 8s ease-in-out infinite reverse;
}


h2 {
  font-family: "serenety";
  font-size: 46px;
  color: #4a3f42;
  margin-bottom: 16px;
  font-weight: 500;

}
p {
  font-size: 15px;
  color: #555;
  margin-bottom: 20px;
  line-height: 1.6;
  font-family: "Poppins", sans-serif;
}
input[type="file"] {
  margin-top: 12px;
  font-size: 14px;
}.btn-success {
  font-size: 15px;
  padding: 12px 28px;
  background-color: #5f6770;
  color: white;  color: #fff;
  border: none;
  border-radius: 40px;
  font-weight: 500;
  font-family: "Playfair Display", serif;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.btn-success:hover {
  background-color: #b8a4b3;
  transform: translateY(-2px);
}

.text-warning {
  color: #8d7f89;
  font-weight: bold;
  font-family: "Poppins", sans-serif;
}
.table {
  width: 100%;
  margin-top: 20px;
  border-collapse: collapse;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
}
.table th,
.table td {
  border: 1px solid #e0d9e3;
  padding: 12px;
  text-align: center;
}
.table th {
  background-color: #b7adb6;
  color: white;
}
.nodisponible {
  margin-top: 280px;
  width: 100%;
  text-align: center;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
  padding: 24px 16px;
}
.nodisponible p {
  font-size: 1.25rem;
  margin-top: 1rem;
  color: #5f5f5f;
  font-family: "Poppins", sans-serif;
}
@media (max-width: 480px) {
  .nodisponible p {
    font-size: 1.05rem;
    margin-top: 1rem;
  }
  .upload-container {
    padding: 30px 18px;
  }
}
.video-float {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 190px;
  height: 90px;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  z-index: 999;
  transition: transform 0.3s ease;
}
.video-float video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.video-tooltip {
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  background: rgba(0, 0, 0, 0.65);
  color: white;
  padding: 2px 8px;
  border-radius: 8px;
  opacity: 0;
  transition: opacity 0.3s;
}
.video-float:hover .video-tooltip {
  opacity: 1;
}

.video-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
.video-modal-content {
  position: relative;
  max-width: 720px;
  width: 90%;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.3);
}
.video-modal-content video {
  width: 100%;
  height: auto;
  display: block;
}
.cerrar-video {
  position: absolute;
  top: 12px;
  right: 12px;
  background: #5f6770;
  color: white;
  font-size: 20px;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  line-height: 30px;
  cursor: pointer;
}


</style>